module.exports = __webpack_public_path__ + "toBride2-we-p-b.2888b59f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-we-p-b.jpg
// module id = bJoV
// module chunks = 0